require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es7.array.includes");

require("core-js/modules/es6.string.includes");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.regexp.match");

require("core-js/modules/es6.regexp.constructor");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.array.filter");

var _toConsumableArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/toConsumableArray");

require("core-js/modules/es6.number.is-nan");

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray");

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.array.sort");

require("core-js/modules/es6.string.trim");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.function.bind");

require("core-js/modules/es6.object.create");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.define-property");

function _createForOfIteratorHelper(o) { if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (o = _unsupportedIterableToArray(o))) { var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var it, normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

module.exports = function (e) {
  var t = {};

  function r(n) {
    if (t[n]) return t[n].exports;
    var o = t[n] = {
      i: n,
      l: !1,
      exports: {}
    };
    return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
  }

  return r.m = e, r.c = t, r.d = function (e, t, n) {
    r.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: n
    });
  }, r.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, r.t = function (e, t) {
    if (1 & t && (e = r(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var n = Object.create(null);
    if (r.r(n), Object.defineProperty(n, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var o in e) {
      r.d(n, o, function (t) {
        return e[t];
      }.bind(null, o));
    }
    return n;
  }, r.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e["default"];
    } : function () {
      return e;
    };
    return r.d(t, "a", t), t;
  }, r.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, r.p = "", r(r.s = 9);
}([function (e, t, r) {
  e.exports = r(4)();
}, function (e, t) {
  e.exports = require("react");
}, function (e, t, r) {
  "use strict";

  var n = r(6),
      o = r(7),
      i = r(8);

  function c(e, t) {
    return t.encode ? t.strict ? n(e) : encodeURIComponent(e) : e;
  }

  function u(e, t) {
    return t.decode ? o(e) : e;
  }

  function a(e) {
    var t = e.indexOf("#");
    return -1 !== t && (e = e.slice(0, t)), e;
  }

  function s(e) {
    var t = (e = a(e)).indexOf("?");
    return -1 === t ? "" : e.slice(t + 1);
  }

  function p(e, t) {
    var r = function (e) {
      var t;

      switch (e.arrayFormat) {
        case "index":
          return function (e, r, n) {
            t = /\[(\d*)\]$/.exec(e), e = e.replace(/\[\d*\]$/, ""), t ? (void 0 === n[e] && (n[e] = {}), n[e][t[1]] = r) : n[e] = r;
          };

        case "bracket":
          return function (e, r, n) {
            t = /(\[\])$/.exec(e), e = e.replace(/\[\]$/, ""), t ? void 0 !== n[e] ? n[e] = [].concat(n[e], r) : n[e] = [r] : n[e] = r;
          };

        case "comma":
          return function (e, t, r) {
            var n = "string" == typeof t && t.split("").indexOf(",") > -1 ? t.split(",") : t;
            r[e] = n;
          };

        default:
          return function (e, t, r) {
            void 0 !== r[e] ? r[e] = [].concat(r[e], t) : r[e] = t;
          };
      }
    }(t = Object.assign({
      decode: !0,
      sort: !0,
      arrayFormat: "none",
      parseNumbers: !1,
      parseBooleans: !1
    }, t)),
        n = Object.create(null);

    if ("string" != typeof e) return n;
    if (!(e = e.trim().replace(/^[?#&]/, ""))) return n;

    var _iterator = _createForOfIteratorHelper(e.split("&")),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _o = _step.value;

        var _i = i(_o.replace(/\+/g, " "), "="),
            _i2 = _slicedToArray(_i, 2),
            _e = _i2[0],
            _c = _i2[1];

        _c = void 0 === _c ? null : u(_c, t), t.parseNumbers && !Number.isNaN(Number(_c)) ? _c = Number(_c) : !t.parseBooleans || null === _c || "true" !== _c.toLowerCase() && "false" !== _c.toLowerCase() || (_c = "true" === _c.toLowerCase()), r(u(_e, t), _c, n);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }

    return !1 === t.sort ? n : (!0 === t.sort ? Object.keys(n).sort() : Object.keys(n).sort(t.sort)).reduce(function (e, t) {
      var r = n[t];
      return Boolean(r) && "object" == typeof r && !Array.isArray(r) ? e[t] = function e(t) {
        return Array.isArray(t) ? t.sort() : "object" == typeof t ? e(Object.keys(t)).sort(function (e, t) {
          return Number(e) - Number(t);
        }).map(function (e) {
          return t[e];
        }) : t;
      }(r) : e[t] = r, e;
    }, Object.create(null));
  }

  t.extract = s, t.parse = p, t.stringify = function (e, t) {
    if (!e) return "";

    var r = function (e) {
      switch (e.arrayFormat) {
        case "index":
          return function (t) {
            return function (r, n) {
              var o = r.length;
              return void 0 === n ? r : null === n ? [].concat(_toConsumableArray(r), [[c(t, e), "[", o, "]"].join("")]) : [].concat(_toConsumableArray(r), [[c(t, e), "[", c(o, e), "]=", c(n, e)].join("")]);
            };
          };

        case "bracket":
          return function (t) {
            return function (r, n) {
              return void 0 === n ? r : null === n ? [].concat(_toConsumableArray(r), [[c(t, e), "[]"].join("")]) : [].concat(_toConsumableArray(r), [[c(t, e), "[]=", c(n, e)].join("")]);
            };
          };

        case "comma":
          return function (t) {
            return function (r, n, o) {
              return null == n || 0 === n.length ? r : 0 === o ? [[c(t, e), "=", c(n, e)].join("")] : [[r, c(n, e)].join(",")];
            };
          };

        default:
          return function (t) {
            return function (r, n) {
              return void 0 === n ? r : null === n ? [].concat(_toConsumableArray(r), [c(t, e)]) : [].concat(_toConsumableArray(r), [[c(t, e), "=", c(n, e)].join("")]);
            };
          };
      }
    }(t = Object.assign({
      encode: !0,
      strict: !0,
      arrayFormat: "none"
    }, t)),
        n = Object.keys(e);

    return !1 !== t.sort && n.sort(t.sort), n.map(function (n) {
      var o = e[n];
      return void 0 === o ? "" : null === o ? c(n, t) : Array.isArray(o) ? o.reduce(r(n), []).join("&") : c(n, t) + "=" + c(o, t);
    }).filter(function (e) {
      return e.length > 0;
    }).join("&");
  }, t.parseUrl = function (e, t) {
    return {
      url: a(e).split("?")[0] || "",
      query: p(s(e), t)
    };
  };
}, function (e, t) {
  e.exports = {
    imagekitProps: {
      alt: "",
      transformations: "",
      httpMethod: "",
      src: "",
      urlEndpoint: "",
      path: ""
    }
  };
}, function (e, t, r) {
  "use strict";

  var n = r(5);

  function o() {}

  function i() {}

  i.resetWarningCache = o, e.exports = function () {
    function e(e, t, r, o, i, c) {
      if (c !== n) {
        var u = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        throw u.name = "Invariant Violation", u;
      }
    }

    function t() {
      return e;
    }

    e.isRequired = e;
    var r = {
      array: e,
      bool: e,
      func: e,
      number: e,
      object: e,
      string: e,
      symbol: e,
      any: e,
      arrayOf: t,
      element: e,
      elementType: e,
      instanceOf: t,
      node: e,
      objectOf: t,
      oneOf: t,
      oneOfType: t,
      shape: t,
      exact: t,
      checkPropTypes: i,
      resetWarningCache: o
    };
    return r.PropTypes = r, r;
  };
}, function (e, t, r) {
  "use strict";

  e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
}, function (e, t, r) {
  "use strict";

  e.exports = function (e) {
    return encodeURIComponent(e).replace(/[!'()*]/g, function (e) {
      return "%".concat(e.charCodeAt(0).toString(16).toUpperCase());
    });
  };
}, function (e, t, r) {
  "use strict";

  var n = new RegExp("%[a-f0-9]{2}", "gi"),
      o = new RegExp("(%[a-f0-9]{2})+", "gi");

  function i(e, t) {
    try {
      return decodeURIComponent(e.join(""));
    } catch (e) {}

    if (1 === e.length) return e;
    t = t || 1;
    var r = e.slice(0, t),
        n = e.slice(t);
    return Array.prototype.concat.call([], i(r), i(n));
  }

  function c(e) {
    try {
      return decodeURIComponent(e);
    } catch (o) {
      for (var t = e.match(n), r = 1; r < t.length; r++) {
        t = (e = i(t, r).join("")).match(n);
      }

      return e;
    }
  }

  e.exports = function (e) {
    if ("string" != typeof e) throw new TypeError("Expected `encodedURI` to be of type `string`, got `" + typeof e + "`");

    try {
      return e = e.replace(/\+/g, " "), decodeURIComponent(e);
    } catch (t) {
      return function (e) {
        for (var t = {
          "%FE%FF": "��",
          "%FF%FE": "��"
        }, r = o.exec(e); r;) {
          try {
            t[r[0]] = decodeURIComponent(r[0]);
          } catch (e) {
            var n = c(r[0]);
            n !== r[0] && (t[r[0]] = n);
          }

          r = o.exec(e);
        }

        t["%C2"] = "�";

        for (var i = Object.keys(t), u = 0; u < i.length; u++) {
          var a = i[u];
          e = e.replace(new RegExp(a, "g"), t[a]);
        }

        return e;
      }(e);
    }
  };
}, function (e, t, r) {
  "use strict";

  e.exports = function (e, t) {
    if ("string" != typeof e || "string" != typeof t) throw new TypeError("Expected the arguments to be of type `string`");
    if ("" === t) return [e];
    var r = e.indexOf(t);
    return -1 === r ? [e] : [e.slice(0, r), e.slice(r + t.length)];
  };
}, function (e, t, r) {
  "use strict";

  r.r(t);
  var n = r(1),
      o = r.n(n),
      i = r(0),
      c = r.n(i),
      u = r(2),
      a = r.n(u),
      s = r(3);

  function p(e) {
    return (p = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    })(e);
  }

  function f() {
    return (f = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var r = arguments[t];

        for (var n in r) {
          Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
        }
      }

      return e;
    }).apply(this, arguments);
  }

  function l(e, t) {
    for (var r = 0; r < t.length; r++) {
      var n = t[r];
      n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
    }
  }

  function y(e, t) {
    return !t || "object" !== p(t) && "function" != typeof t ? function (e) {
      if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return e;
    }(e) : t;
  }

  function d(e) {
    return (d = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function b(e, t) {
    return (b = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }

  var h,
      m,
      g,
      O = function (e) {
    function t() {
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, t), y(this, d(t).apply(this, arguments));
    }

    var r, n, i;
    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && b(e, t);
    }(t, o.a.Component), r = t, (n = [{
      key: "transformationBuilder",
      value: function value() {
        return this.props.transformations.map(function (e) {
          return Object.keys(e).map(function (t) {
            return "".concat(t, "-").concat(e[t]);
          }).join(",");
        }).join(":");
      }
    }, {
      key: "linkBuilder",
      value: function value() {
        var e = this.props.src || this.props.urlEndpoint + this.props.path,
            t = this.transformationBuilder();
        console.log("TR:", t);
        var r = a.a.parseUrl(e),
            n = r.query.tr ? r.query.tr + t : t;
        n && (r.query.tr = n);
        var o = a.a.stringify(r.query, {
          arrayFormat: "comma"
        });
        return o ? r.url + "?" + o : r.url;
      }
    }, {
      key: "render",
      value: function value() {
        var e = this,
            t = this.linkBuilder(),
            r = Object.keys(this.props).reduce(function (t, r) {
          return Object.keys(s.imagekitProps).includes(r) || (t[r] = e.props[r]), t;
        }, {});
        return o.a.createElement("img", f({
          src: t,
          alt: this.props.alt || ""
        }, r));
      }
    }]) && l(r.prototype, n), i && l(r, i), t;
  }(),
      j = O;

  O.propTypes = (h = {
    alt: c.a.string,
    path: c.a.string,
    transformations: c.a.arrayOf(c.a.object),
    httpMethod: c.a.oneOf("http", "https"),
    src: c.a.string,
    urlEndpoint: function urlEndpoint(e, t, r) {
      if (!e.src && !e.urlEndpoint) return new Error("Atleast one of props 'urlEndpoint' or 'src' should be specified in '".concat(r, "'."));
    }
  }, g = function g(e, t, r) {
    if (e.src && e.urlEndpoint) return new Error("Both the props 'urlEndpoint' or 'src' should not be specified in '".concat(r, "'."));
  }, (m = "src") in h ? Object.defineProperty(h, m, {
    value: g,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : h[m] = g, h), O.defaultProps = {
    httpMethod: "https",
    transformations: []
  };
  t["default"] = j;
}]);